/**
 * extensionConstants — Single source of truth per l'URL dello Chrome Web Store
 * dell'estensione Pronto Publisher.
 *
 * Quando Google approva l'estensione (1-7 giorni dopo submission), aggiorna
 * SOLO la costante `CHROME_STORE_URL` qui sotto e ridistribuisci con Deploy.
 * Tutti i CTA della landing `/estensione`, del banner dashboard, dei toast
 * di lancio e (in futuro) del wizard prima-pubblicazione punteranno
 * automaticamente al link corretto.
 *
 * Formato URL Chrome Web Store:
 *   https://chromewebstore.google.com/detail/pronto-publisher/{ID}
 *
 * Lo `EXTENSION_LIVE` flag controlla se l'estensione è già pubblica:
 *  - false → il banner mostra "Stiamo aspettando l'OK di Google" + waitlist
 *  - true  → il banner mostra "Installa l'estensione" → Store
 *
 * Dopo l'approvazione: settare `EXTENSION_LIVE = true` E `CHROME_STORE_URL`.
 */

export const CHROME_STORE_URL = "https://chromewebstore.google.com/detail/pronto-publisher/lpjnfaedimfkfkdadoldehanceggjgpn";
export const EXTENSION_LIVE = true;
export const CHROME_EXTENSION_ID = "lpjnfaedimfkfkdadoldehanceggjgpn";

// Localstorage key che il content script dell'estensione setta a "1" appena
// l'utente apre la dashboard col plugin attivo. Usata per nascondere il banner
// di launch a chi ha già l'estensione.
export const EXTENSION_INSTALLED_LS_KEY = "pronto_publisher_installed";

// Localstorage key per ricordare quando l'utente ha cliccato "ricordamelo dopo"
// sul banner launch. Lo nascondiamo per 7 giorni.
export const EXTENSION_BANNER_SNOOZED_LS_KEY = "pronto_publisher_banner_snoozed_until";
